<template>
    <img :style="{ cursor: 'pointer' }" :width="schema.width" :height="schema.height" :src="value" @click="onClick"/>
</template>

<script>
   import { abstractField } from "vue-form-generator";

   export default {
    mixins: [ abstractField ],
    methods: {
        onClick($event) {
            this.schema.onClick.call(this, this.model, this.schema, $event, this);
        }
    }
   };
</script>